//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GeneralTable from '@/components/GeneralTable';
import { log } from 'util';
import checkPermission from '@/utils/permission'; // 权限判断函数

export default {
  name: 'Index',
  components: {
    GeneralTable: GeneralTable
  },
  data: function data() {
    return {
      tableName: 't_role',
      url: {
        getUrl: '/role',
        method: 'post',
        query: {}
      },
      canSearch: checkPermission('master.role.list'),
      //true,
      canAdd: checkPermission('master.role.add'),
      //true,
      canEdit: checkPermission('master.role.edit'),
      //true,
      canDelete: checkPermission('master.role.delete'),
      //true,
      canBatchEdit: checkPermission('master.role.batch'),
      //true,
      canDownload: checkPermission('master.role.download') //true
    };
  },
  created: function created() {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 保存离开本页面时的查询条件，当再次进入本页面时回显
    if (this.$refs.GeneralTable) {
      sessionStorage.setItem(window.location.href + '_LIST_QUERY', JSON.stringify(this.$refs.GeneralTable.getListQuery()));
    }
    next();
  },
  methods: {}
};